module.exports = __webpack_public_path__ + "img/dishwasher.983d1ef0.png";